import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useStoreUnit, StoreUnit } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<StoreUnit>
    useData={useStoreUnit}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
